import React from 'react';
import { Box } from '@mui/material';
import type { IncidentDrawerDetailScope } from './incidentDrawerDetailTypes';

export function IncidentDrawerDetailStep5({ scope }: { scope: IncidentDrawerDetailScope }) {
  const s = scope as any;
  return (
    <Box ref={s.drawerStep5Ref} sx={s.stepSectionSx('step5')}>
      {s.reviewerActionPanel}
      {!s.groupedReviewMode ? s.renderStepNavigation('step5') : null}
    </Box>
  );
}
